import { markStale } from '../resolvers/definition/resolverState';
import { produceNextCacheEntry } from './lifecycleTransition';
import { createEntityCache } from './entityCache';
export const createEntityLifecycleManager = ({
  onInvalidate,
  onStateChange
}) => {
  const cache = createEntityCache();
  const set = (entity, instanceKey, entry) => {
    cache.set(entity, instanceKey, entry);
    onStateChange(entity, instanceKey, entry.state);
  };
  return {
    // Bounce back to controller for now — will trigger invalidation
    // propagation in the future
    invalidate: onInvalidate,
    getState: (entity, instanceKey) => {
      var _cache$get;
      return (_cache$get = cache.get(entity, instanceKey)) === null || _cache$get === void 0 ? void 0 : _cache$get.state;
    },
    markStale: (entity, instanceKey) => {
      const entry = cache.get(entity, instanceKey);
      if (entry && !entry.state.stale) {
        const nextEntry = produceNextCacheEntry({
          entity,
          currentEntry: entry,
          nextState: markStale()(entry.state)
        });

        // Only update + emit if the node became stale
        if (nextEntry.state.stale) {
          set(entity, instanceKey, nextEntry);
        }
      }
    },
    handleStateChange: (entity, instanceKey, state) => set(entity, instanceKey, produceNextCacheEntry({
      entity,
      currentEntry: cache.get(entity, instanceKey),
      nextState: state
    })),
    __devtools: {
      cache: cache.__devtools
    }
  };
};